/**
 * Created by swandelow on 09/03/18.
 */
import {Component, OnInit} from "@angular/core";
import {CookieService} from "ngx-cookie";
import {SessionService} from "../../core/session.service";
import {LoadingWheelService} from "../../root/loading/loading-wheel.service";
import {LogoutService} from "../../core/logout.service";

@Component({
    selector: "logout-component",
    templateUrl: "./logout.component.html"
})

export class LogoutComponent implements OnInit {
    langLogo: string;

    constructor(
        private cookieService: CookieService,
        private logoutService: LogoutService,
        private sessionService: SessionService,
        private loadingWheelService: LoadingWheelService
    ) {}

    ngOnInit(): void {
        this.setLogoutCountryLogo();
        this.loadingWheelService.show();
        this.logoutService.save()
            .subscribe(response => {
                this.sessionService.cleanSession();
                window.location.href = "../login-atp3";
                this.loadingWheelService.hide();
            });
    }

    setLogoutCountryLogo() {
        const langCookie: string = this.cookieService.get('sara_language') || 'spanish';
        let logoName: string = 'assets/logo-sidebar';

        this.langLogo = (langCookie.includes('portuguese')) ? `${logoName}-pr.png` : `${logoName}.png`;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/logout/logout.component.ts